const slide = (e, r, t = !1) => {
    const l = e.querySelectorAll(".slider--slide").length;
    let s;
    t ? s = r : (s = Number(e.dataset.currentIndex), (s += r) > l - 1 && (s -= l))

    e.dataset.currentIndex = String(s)

    e.querySelectorAll(".slider--slide").forEach((el, i) => {
        i === s ? el.classList.add("active") : el.classList.remove("active")
    })

    e.parentElement.querySelectorAll(".slider--control-wrapper--btn").forEach((e, r) => {
        r === s ? e.classList.add("active") : e.classList.remove("active")
    })
}

document.querySelectorAll('.slider--container[data-bow-slider="true"]').forEach(e => {

    var r;

    const t = null !== (r = Number(e.dataset.slideSpeed)) && void 0 !== r ? r : 2e3,
        l = e.querySelector(".slider--slide--container");

    if (l.querySelectorAll(".slider--slide").length < 2)
        return;

    let s = setInterval(() => {
        slide(l, 1)
    }, t);

    e.addEventListener("mouseenter", () => {
        clearInterval(s), s = 0
    })

    e.addEventListener("mouseleave", () => {
        console.debug('MoseLeave')
        s || (s = setInterval(() => {
            slide(l, 1)
        }, t))
    })

    e.querySelectorAll(".slider--control-wrapper--btn").forEach(e => {
        e.addEventListener("click", () => {
            slide(l, Number(e.dataset.slideTarget), !0)
        })
    })

    let touchStartX = 0;
    let touchEndX = 0;

    l.addEventListener("touchstart", (e) => {
        clearInterval(s);
        touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    l.addEventListener("touchend", (e) => {

        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;

        if( Math.abs(diff) < 50 )
            return

        if (diff > 0) {
            slide(l, 1);
        } else {
            slide(l, -1);
        }

    }, { passive: true });
});
//# sourceMappingURL=bow-slider.js.map
